import { render, staticRenderFns } from "./LawyerViewPage.vue?vue&type=template&id=ebc2cb20"
import script from "./LawyerViewPage.vue?vue&type=script&lang=js"
export * from "./LawyerViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports